<template>
  <div class="banner">
    <img :src="require('@/assets/banner1-b582a278.jpg')" alt="" />
    <div class="banner-box">
      <div class="banner-text">
        <h2>太扬翔药业</h2>
        <p></p>
        <h3>以匠心淬炼，缔造行业新典范</h3>
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 100%;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  .banner-box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.1);

    .banner-text {
      width: 70%;

      h2 {
        text-align: right;
        font-size: 80px;
        color: white;
        font-family: "Courier New", Courier, monospace;
      }
      p {
        width: 100%;
        height: 5px;
        border-right: 10.5rem solid white;
        box-sizing: border-box;
        margin: 20px 0;
      }
      h3 {
        text-align: right;
        font-size: 40px;
        color: white;
        font-family: "Courier New", Courier, monospace;
      }
    }
  }
}

@media (max-width: 610px) {
  .banner {
    width: 100%;
    position: relative;

    img {
      width: 100%;
      height: 200px;
    }

    .banner-box {
      .banner-text {
        width: 85%;

        h2 {
          font-size: 40px;
        }
        p {
          height: 3px;
          border-right: 100px solid white;
        }
        h3 {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
